import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles/styles.scss";
import "./styles/general.scss";
import "./styles/educativo.scss";
import "./styles/servicios.scss";
import "./styles/fisp-tv.scss";
import "./styles/admin.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

